import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';

export const NotificationCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    margin-bottom: ${theme.layout.spacing.decy};
  `}
`;

export const ReportResultsCont = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.deka} 0 0 0;
  `}
`;

export const ResultTableTitle = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  font-size: 17px;
  letter-spacing: 0.08em;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;
